import classNames from "classnames";
import type { FC } from "react";
import { useState } from "react";
import { naturalRatio, ratioStyle } from "./imageRatio";
import styles from "./pp2Header.module.scss";

export type Pp2HeroProps = {
  url: string;
  onError: () => void;
};

/**
 * The hero (spec 3.3). Once the image has loaded, its box takes the image's aspect ratio within a
 * height range per breakpoint, and the image covers it: a wide image is shown whole at full width,
 * and one taller than the range allows is cropped only by what does not fit.
 */
export const Pp2Hero: FC<Pp2HeroProps> = ({ url, onError }) => {
  const [loaded, setLoaded] = useState(false);
  // Unknown for an image without a size: the box then keeps its default height (3.3)
  const [ratio, setRatio] = useState<number | null>(null);
  return (
    <div className={classNames(styles.hero, ratio !== null && styles.sized)} style={ratioStyle("--hero-ratio", ratio)}>
      <img
        // Hidden until it has loaded and the box has its height, so no frame shows the wrong crop
        className={classNames(styles.heroImage, !loaded && styles.sizePending)}
        src={url}
        alt=""
        data-test-id="pp2-hero"
        onLoad={(event) => {
          setRatio(naturalRatio(event.currentTarget));
          setLoaded(true);
        }}
        onError={onError}
      />
    </div>
  );
};
